'use strict';

import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

(function() {
  angular
    .module('specsguardApp')
    .controller('AreasMatrixCtrl', AreasMatrixCtrl);

  AreasMatrixCtrl.$inject = ['$stateParams', 'Labels', 'sg2ProjectService', 'projectLevel', '$location',
  'sg2MatrixService', 'sg2FloorAreaService', 'sgAreaInheritanceHelpers', 'filterModuleFactory', 'sg2AuthService'];

  function AreasMatrixCtrl($stateParams, Labels, sg2ProjectService, projectLevel, $location,
    sg2MatrixService, sg2FloorAreaService, sgAreaInheritanceHelpers, filterModuleFactory, sg2AuthService) {

    const vm = this;

    vm.canCreateCSV = sg2AuthService.canCreate('excel');

    const {
      project_id: projectId,
      building_id: buildingId
    } = $stateParams;

    const destroy$ = new Subject();

    vm.project = sg2ProjectService.get();
    sg2ProjectService.project$.pipe(
      skip(1),
      takeUntil(destroy$)
    ).subscribe(p => {
      vm.project = JSON.parse(JSON.stringify(p));
    });

    /**
     * Enable loader on init.
     *
     * Because the loader may get stuck on rendering, the call to parse the model is
     * delayed by half a second.
     */
    vm.$onInit = () => {
      setLoading(true);
      setTimeout(() => setModel(), 500);
    };

    /** Unsubscribe. */
    vm.$destroy = () => {
      destroy$.next();
      destroy$.complete();
    };

    vm.LABELS = Labels;
    vm.loading = true;
    vm.headers = [];
    vm.arr = [];
    vm.areaCount = 0;
    vm.emptyMatrix = false;
    vm.getTotalFNO = getTotalFNO;
    vm.openArea = openArea;
    vm.config = {
      areas: '/project/' + projectId + '/building/' + buildingId + '/areas',
    };

    /**
     * Set loading screen.
     *
     * @param active Enable or disable the loading screen.
     */
    function setLoading(active: boolean): void {
      vm.loading = active;
    }

    vm.exportMatrix = exportMatrix;

    const setModel = () => {
      const techModules = vm.project.modules.filter((module) => module.isTechnicalType && module.viewtab === 'technisch');
      const building = vm.project.buildings.find((bld) => bld._id.toString() === buildingId.toString());

      vm.loading = true;

      vm.model = {
        project: vm.project,
        building: building,
        modules: techModules,
      };

      createAreaMods();
      renderHeader();
      cleanUpHeader();

      setLoading(false);
    };

    // Helpers
    function renderHeader () {
      // Let's loop through the areas first
      vm.model.building.clusters.forEach(cluster => {
        cluster.areas.forEach(area => {
          const modules = filterElements(vm.model.modules, area, vm.model.project);

          const header = {
            _id: area._id,
            modules: mappedModules(modules)
          };

          vm.headers.push(header);
        });
      });
    }

    function mappedModules (modules) {
      return modules.map( item => {
        const module = {
          moduleId: item._id,
          name: item.name,
          submodules: item.submodules.map( sItem => {
            const submodule = {
              submoduleId: sItem._id,
              name: sItem.name,
              elements: sItem.elements.map( element => {
                return {
                  elementId: element._id,
                  name: element.name,
                  unit: element.unit,
                  value: element.value,
                  moduleId: item._id,
                  submoduleId: sItem._id,
                };
              })
            };

            return submodule;
          })
        };
        return module;
      });
    }

    function filterElements (modules, area, project) {
      const setBasicAreaId = area.basicArea.hasOwnProperty('_id') ? area.basicArea._id : area.basicArea;

      let mods =  JSON.parse(JSON.stringify(modules));
      mods = sgAreaInheritanceHelpers.overwriteBasicAreaElements(mods, area._id, setBasicAreaId, project);
      mods = filterModuleFactory.addBasicAreaMarker(mods, area._id);
      mods = filterModuleFactory.filterBasicAreaElements(mods, true);
      mods = filterModuleFactory.removeEmptySubmodules(mods);

      return mods;
    }

    function areaCounter () {
      vm.areaCount = vm.areaCount + 1;
    }

    // function emptyMatrix() {
    //   vm.loading = false;
    //   vm.emptyMatrix = false;
    // }

    /**
     * createAreaMods
     * Add the modules per area
     */
    function createAreaMods() {
      if (vm.model.building.clusters.length) {
        vm.model.building.clusters.forEach((cluster) => {
          if (cluster.areas.length) {
            cluster.areas.forEach((area) => {
              if (area.active) {
                area.mods = filterModules(area);
                area.mods = filterElements(area.mods, area, vm.model.project);
                area.projectLevel = projectLevel;
                areaCounter();
              }
              return area;
            });
          }
        });
      }
    }

    /**
     * cleanUpHeader
     *
     */
    function cleanUpHeader() {
      // First time we create the header
      let submoduleElements = [];

      for (const idx in vm.headers) {
        if (!vm.arr.length) {
          vm.arr.push(vm.headers[idx].modules);
        } else {
          // Each area header needs to be compared with the previous and merged together
          for (const id in vm.headers[idx].modules) {
            if ( vm.headers[idx].modules[id]) {
              for (const sId in vm.headers[idx].modules[id].submodules) {
                if ( typeof vm.arr[0][id].submodules[sId] !== 'undefined' ) {
                  submoduleElements = vm.arr[0][id].submodules[sId].hasOwnProperty('elements') ?
                    vm.arr[0][id].submodules[sId].elements : [];
                    vm.arr[0][id].submodules[sId].elements = Array.from(
                      new Set([
                        ...submoduleElements,
                        ...vm.headers[idx].modules[id].submodules[sId].elements
                      ])
                    );
                } else {
                  vm.arr[0][id].submodules[sId] = Object.assign({}, vm.headers[idx].modules[id].submodules[sId].elements);
                }
              }
            }
          }
        }
      }

      vm.renderedHeaders = vm.arr[0];
    }

    /**
     * FilterModuels
     *
     * return modules based on the viewtab
     */
    function filterModules (area) {
      const mods = JSON.parse(JSON.stringify(vm.model.modules));
      return mods.filter((mod) => mod.viewtab === 'technisch');
    }

    /**
     * exportMatrix()
     *
     * Send the actual table data to the matrix.service
     */
    function exportMatrix () {
      const headers = document.getElementsByClassName('table-header');
      const body = document.getElementById('matrix-table__body');
      sg2MatrixService.prepare(headers, body, vm.model.building.name);
    }

    /**
     * getTotalFNO
     */
    function getTotalFNO (area) {
      return sg2FloorAreaService.getAreaFNO(area);
    }

    /**
     * openArea
     */
    function openArea (areaId) {
      const route = `/project/${projectId}/building/${buildingId}/areas/${areaId}`;
      $location.path(route);
    }
  }
})();
